import Helper from './Helper';

class Dropdown {
  constructor(element) {
    // console.log('constructor');
    this.element = element;
    this.elementID = this.element.id;
    this.submenuToggler = this.element.querySelectorAll('.menu__item--has-children .menu__link');
    this.togglerArray = Array.prototype.slice.call(this.submenuToggler);
		this.bindEvents();
		this.selectCurrent();
  }

  bindEvents() {
    // console.log('bindEvents function');
    this.togglerArray.forEach(toggler =>
      toggler.addEventListener('click', e => {
        // console.log('submenu toggler click');
        this.toggleSubmenu(toggler, e);
      })
    );
  }

	selectCurrent(){
		const currentText = this.element.querySelector('.menu__item--active');
		const chooserText = this.element.querySelector('.menu__link-text--0');
		if(currentText){
			console.log(chooserText);
			// chooserText.innerHTML = 'bla';
			chooserText.innerHTML = `<span class="key">${chooserText.innerText}:</span> <span class="value">${currentText.innerText}</span>`;
			console.log(currentText.innerText);
		}
	}

  toggleSubmenu(toggler, e) {
    // console.log('toggleSubmenu function');
    let parent = toggler.parentElement;
    let child = parent.querySelector('.menu--level-1');
    let menu = this.element;
    let targetParent = Helper.getClosest(
      e.target,
      '.menu__item--ancestor-open'
    );

    if (menu.querySelector(`.menu__item--ancestor-open`) !== null) {
      Helper.slideUp(menu.querySelector('.menu--submenu-open'), 200);

      menu.querySelector(`.menu__item--ancestor-open`).classList.remove('menu__item--ancestor-open');
      menu.querySelector(`.menu--submenu-open`).classList.remove('menu--submenu-open');

      if (targetParent !== null) {
        // Helper.removeClass(document.querySelector('body'), 'menu-open');
        parent.classList.remove('menu__item--ancestor-open');
        child.classList.remove('menu--submenu-open');
      } else {
        Helper.addClass(document.querySelector('body'), 'menu-open');
        parent.classList.add('menu__item--ancestor-open');
        child.classList.add('menu--submenu-open');
      }
    } else {
      Helper.addClass(document.querySelector('body'), 'menu-open');
      parent.classList.add('menu__item--ancestor-open');
      child.classList.add('menu--submenu-open');
    }

    Helper.slideToggle(child, 200);
  }
}

export default Dropdown;
